import { FaPlus, FaTimes } from "react-icons/fa";
import { PrimaryButton, SecondaryButton } from "../../../UI/DesignStandards";
import { NestedItemFormSection } from "../../../DesignSystem";
import CreateAdditionalPrizeFundForm from "../CreateAdditionalPrizeFundForm";

const PrizeFundAddForm = ({
  showAddForm,
  newPrizeFund,
  validationErrors,
  isSubmitting,
  onAddPrizeFund,
  onCancel,
  onDescriptionChange,
  onAmountChange,
}) => {
  if (!showAddForm) return null;

  return (
    <NestedItemFormSection
      title="Add New Prize Fund"
      onClose={onCancel}
      className="mb-6"
    >
      <CreateAdditionalPrizeFundForm
        description={newPrizeFund.description}
        setDescription={onDescriptionChange}
        amount={newPrizeFund.amount}
        setAmount={onAmountChange}
        error={validationErrors.new}
      />
      {validationErrors.new && (
        <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2 mt-3">
          {validationErrors.new}
        </div>
      )}
      <div className="flex justify-end space-x-3 pt-4">
        <SecondaryButton onClick={onCancel}>
          <FaTimes className="mr-2" />
          Cancel
        </SecondaryButton>
        <PrimaryButton onClick={onAddPrizeFund} disabled={isSubmitting}>
          {isSubmitting ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
              Adding...
            </>
          ) : (
            <>
              <FaPlus className="mr-2" />
              Save
            </>
          )}
        </PrimaryButton>
      </div>
    </NestedItemFormSection>
  );
};

export default PrizeFundAddForm;
